import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import { IGroupCourse } from 'types'
import { Form, Formik } from 'formik'
import { AppDispatch, RootState } from 'redux/store'
import { 
  setSummary, 
  setGroupCourse, 
  setCourseComponent,
  setStudent, 
  setAcademicYear, 
  setGradeLevel, 
  setGroup, 
  setAcademicPeriod,
  setDateAssignedFrom,
  setDateAssignedTo,
} from 'redux/ui/groupCourseGradebookUI'
import { academicYearSelectData, downloadFile, gradeSelectData } from 'utils/helpers'
import SelectField from 'components/atoms/fields/SelectField'
import CheckboxField from 'components/atoms/fields/CheckboxField'
import formModel, { initialValues } from 'utils/tableFilterModels/groupCourseGradebookTableFilterModel'
import { useGET_groupCourseSelectQuery } from 'redux/api/groupCoursesApi'
import { useGET_groupSelectQuery } from 'redux/api/groupsApi'
import { useGET_studentsProfileSelectQuery } from 'redux/api/studentsApi'
import { Button } from '@mui/material'
import { FaFileDownload } from 'react-icons/fa'
import { useGET_academicPeriodsSelectQuery } from 'redux/api/academicPeriodsApi'
import { useTranslation } from 'react-i18next'
import DatePickerField from 'components/atoms/fields/DatePickerField'
import { format } from 'date-fns'
import { useGET_courseComponentsSelectQuery } from 'redux/api/coursesApi'
import { PRIMARY_ORANGE, PURE_BLACK } from 'utils/customizedTheme'
import { useGET_myGradeLevelsQuery } from 'redux/api/mySchoolApi'


interface IProps {
    groupCourse: IGroupCourse
}
  
const GroupCourseGradebookFilters: FC<IProps> = ({ groupCourse }) => {
  const reduxKey = 'groupCourseGradebook';
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation()

  const gradebook_type = useSelector((state: RootState) => state[reduxKey].gradebook_type)

  const { 
    summary, 
    academic_year,
    academic_period,
    grade_level, 
    group, 
    group_course, 
    student,
    course_component,
    date_assigned_from,
    date_assigned_to
  } = formModel()

  const { data: myGradeLevels } = useGET_myGradeLevelsQuery()
  const availableGradeLevels = myGradeLevels ? myGradeLevels : {}

  return (
    <>
      <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={(values) => { 

          }}>
            {({ values, setFieldValue }) => (
            <Form>
              <Grid container spacing={2} mb={5}>
                <Grid item xs={12} lg={10}>

                  <Grid container spacing={2}>
                    <Grid item xs={12} lg={3}>
                          <SelectField
                            fieldProps={{ ...academic_year }}
                            apiCall={academicYearSelectData}
                            onChange={(value) => {
                                setFieldValue('academic_period', null)
                                setFieldValue('grade_level', null)
                                setFieldValue('group', null)
                                setFieldValue('group_course', null)
                                setFieldValue('course_component', null)
                                setFieldValue('student', null)
                                setFieldValue('date_assigned_from', null)
                                setFieldValue('date_assigned_to', null)
                                dispatch(setAcademicYear(value?.id ?? null))
                                dispatch(setAcademicPeriod(null))
                                dispatch(setGradeLevel(null))
                                dispatch(setGroup(null))
                                dispatch(setGroupCourse(null))
                                dispatch(setCourseComponent(null))
                                dispatch(setStudent(null))
                                dispatch(setDateAssignedFrom(null))
                                dispatch(setDateAssignedTo(null))
                            }}
                          />
                    </Grid> 

                    {["my-gradebook-assignments", "gradebook-assignments"].includes(gradebook_type) && 
                    <Grid item xs={12} lg={4}>
                            <SelectField
                              fieldProps={{ ...academic_period }}
                              apiCall={useGET_academicPeriodsSelectQuery}
                              onChange={(value) => {
                                setFieldValue('date_assigned_from', null)
                                setFieldValue('date_assigned_to', null)
                                dispatch(setAcademicPeriod(value?.id ?? null))
                                dispatch(setDateAssignedFrom(null))
                                dispatch(setDateAssignedTo(null))
                              }}
                            />
                    </Grid>}


                    { !groupCourse && <>

                      { values?.academic_year &&
                          <Grid item xs={6} lg={2}>
                              <SelectField
                                fieldProps={{ ...grade_level }}
                                apiCall={gradeSelectData}
                                filters={gradebook_type === 'my-gradebook-assignments' ? availableGradeLevels : {}}
                                onChange={(value) => {
                                  setFieldValue('group', null)
                                  setFieldValue('group_course', null)
                                  setFieldValue('course_component', null)
                                  setFieldValue('student', null)
                                  dispatch(setGradeLevel(value?.id ?? null))
                                  dispatch(setGroup(null))
                                  dispatch(setGroupCourse(null))
                                  dispatch(setCourseComponent(null))
                                  dispatch(setStudent(null))
                                }}
                              />
                          </Grid> 
                      }

                      {  values?.grade_level &&
                        <Grid item xs={6} lg={2}>
                            <SelectField
                              fieldProps={{ ...group }}
                              apiCall={useGET_groupSelectQuery}
                              filters={{
                                academic_year: values?.academic_year?.id, 
                                grade_level: values?.grade_level?.id
                              }}
                              onChange={(value) => {
                                setFieldValue('group_course', null)
                                setFieldValue('course_component', null)
                                setFieldValue('student', null)
                                dispatch(setGroup(value?.id ?? null))
                                dispatch(setGroupCourse(null))
                                dispatch(setCourseComponent(null))
                                dispatch(setStudent(null))
                              }}
                            />
                        </Grid> 
                      }

                      { values?.group &&
                        <Grid item xs={12} lg={4}>
                            <SelectField
                            fieldProps={{ ...group_course }}
                            filters={{
                              group: values?.group?.id
                            }}
                            apiCall={useGET_groupCourseSelectQuery}
                            onChange={(value) => {
                              setFieldValue('course_component', null)
                                setFieldValue('student', null)
                                dispatch(setGroupCourse(value?.id ?? null))
                                dispatch(setCourseComponent(null))
                                dispatch(setStudent(null))
                            }}
                            />
                        </Grid> 
                      }
                    </>}

                    { values?.group_course?.id &&  <>

                      {["my-gradebook-assignments", "gradebook-assignments"].includes(gradebook_type) && 
                          <Grid item xs={12} lg={3}>
                            <SelectField
                              fieldProps={{ ...course_component }}
                              filters={{group_course: values?.group_course?.id}}
                              apiCall={useGET_courseComponentsSelectQuery}
                              onChange={(value) => {
                                  dispatch(setCourseComponent(value?.id ?? null))
                              }}
                            />
                          </Grid>
                      } 

                      {gradebook_type !== 'gradebook-student' && 
                      <Grid item xs={12} lg={4}>
                          <SelectField
                            fieldProps={{ ...student }}
                            filters={{
                              group_course: values?.group_course?.id
                            }}
                            apiCall={useGET_studentsProfileSelectQuery}
                            onChange={(value) => {
                                dispatch(setStudent(value?.id ?? null))
                            }}
                          />
                      </Grid>} 
                 
                      {["my-gradebook-assignments", "gradebook-assignments"].includes(gradebook_type) && <>     
                        <Grid item xs={12} lg={5}>
                          <Grid container spacing={2}>
                              <Grid item xs={12} lg={6}>
                                <DatePickerField
                                  fieldProps={{ ...date_assigned_from }}
                                  onChange={(value: Date) => {
                                    dispatch(setDateAssignedFrom(value ? format(value, 'yyyy-MM-dd') : ''))
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} lg={6}>
                                <DatePickerField
                                  fieldProps={{ ...date_assigned_to }}
                                  onChange={(value: Date) => {
                                    dispatch(setDateAssignedTo(value ? format(value, 'yyyy-MM-dd') : ''))
                                  }}
                                />
                              </Grid>
                          </Grid>
                        </Grid>
                      </>}

                       {gradebook_type === 'gradebook' &&  values?.group_course?.id && 
                          <Grid item xs={12} lg={2}>
                            <CheckboxField
                              isSwitch
                              fieldProps={{ ...summary }}
                              onChange={(value: any) => {
                                  dispatch(setSummary(value))
                              }}
                            />
                        </Grid>} 
                      
                    </> }
                  </Grid>
                </Grid>

                <Grid item xs={12} lg={2}>
                    {['my-gradebook-assignments', 'gradebook-assignments'].includes(gradebook_type) &&
                    <Button 
                      variant='contained'
                      color='success'
                      onClick={() => window.location.href = '/assignments/add'}
                      className='small-button'
                    >
                      + {`${t('common.add-assignment')}`}
                    </Button>}

                    { values?.academic_year && values?.group_course && 
                    <span onClick={() => {

                        if(values?.academic_year){
                          downloadFile(`/gradebook-grid-download-report/${values?.academic_year.id}/`, {
                            group_course_id: values?.group_course?.id || '', 
                            student_id: values?.student?.id || '',
                            is_final: values?.summary ? 'true' : ''
                          })
                        }

                    }} style={{ marginTop: '20px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <FaFileDownload color={PRIMARY_ORANGE}/> 
                        <span style={{ marginLeft: '5px', color: PURE_BLACK, fontSize: '12px', textDecoration: 'underline' }}>
                          {t('common.download-detailed-report')}</span>
                    </span>
                    }
                </Grid>

              </Grid>

            </Form>
          )}
      </Formik>
    </>
  )
}
export default GroupCourseGradebookFilters